export default {
  dbi_casual_genre_profile: 'Casual Genre Profile',
  dbi_casual_genre_profile_sub_title: 'Any questions can contact GRC tedni',
  dbi_casual_genre_breakdown: 'GENRE\nBREAKDOWN',
  // MetricSegment
  dbi_casual_metric_download: 'Downloads',
  dbi_casual_metric_mau: 'MAU',
  dbi_casual_metric_revenue: 'Revenue($)',
  // ChartsSection - SensorTower Main Genre
  dbi_casual_genre_share_main_genre: 'Genre Share - Main Genre',
  dbi_casual_genre_trend_main_genre: 'Genre Trend - Main Genre',
  // ChartsSection - SensorTower Sub Genre
  dbi_casual_genre_share_sub_genre: 'Genre Share - Sub Genre',
  dbi_casual_genre_trend_sub_genre: 'Genre Trend - Sub Genre',
  // ChartsSection - AppMagic Super Genre
  dbi_casual_genre_share_super_genre: 'Genre Share - Super Genre',
  dbi_casual_genre_trend_super_genre: 'Genre Trend - Super Genre',
  // ChartsSection - AppMagic Level-1 Genre (major_category)
  dbi_casual_genre_performance_level1_genre: 'Genre Performance - Level-1 Genre',
  dbi_casual_genre_trend_level1_genre: 'Genre Trend - Level-1 Genre',
  // ChartsSection - AppMagic Level-2 Genre (mid_category)
  dbi_casual_genre_performance_level2_genre: 'Genre Performance - Level-2 Genre',
  dbi_casual_genre_trend_level2_genre: 'Genre Trend - Level-2 Genre',
  // ChartsSection - AppMagic Level-3 Genre (sub_category)
  dbi_casual_genre_performance_level3_genre: 'Genre Performance - Level-3 Genre',
  dbi_casual_genre_trend_level3_genre: 'Genre Trend - Level-3 Genre',

  // MetricDataGames
  dbi_casual_top_games: 'Top Games',
  dbi_casual_rising_games: 'Rising Games',
  dbi_casual_game: 'Game',

  // DimensionSelect
  dbi_casual_dimension_by_genre: 'Dimension By Genre',
  dbi_casual_dimension_main_genre: 'Main Genre',
  dbi_casual_dimension_sub_genre: 'Sub Genre',
  dbi_casual_dimension_super_genre: 'Super Genre',
  dbi_casual_dimension_level1_genre: 'Level-1 Genre',
  dbi_casual_dimension_level2_genre: 'Level-2 Genre',
  dbi_casual_dimension_level3_genre: 'Level-3 Genre',

  // TableSegment
  dbi_casual_table_segment_metrics: 'Metrics',
  dbi_casual_table_segment_top_games: 'Top Games',
  dbi_casual_table_segment_rising_games: 'Rising Games',

  dbi_casual_noteworthy_games: 'Noteworthy Games',

  // GenreTable columns
  dbi_casual_table_col_main_genre: 'Main Genre',
  dbi_casual_table_col_sub_genre: 'Sub Genre',
  dbi_casual_table_col_super_genre: 'Super Genre',
  dbi_casual_table_col_level1_genre: 'Level-1 Genre',
  dbi_casual_table_col_level2_genre: 'Level-2 Genre',
  dbi_casual_table_col_level3_genre: 'Level-3 Genre',
  dbi_casual_table_col_download: 'Downloads',
  dbi_casual_table_col_mau: 'MAU',
  dbi_casual_table_col_revenue: 'Revenue($)',
  dbi_casual_table_col_top_games_by_download: 'Top Games by Downloads',
  dbi_casual_table_col_top_games_by_dau: 'Top Games by DAU',
  dbi_casual_table_col_top_games_by_wau: 'Top Games by WAU',
  dbi_casual_table_col_top_games_by_mau: 'Top Games by MAU',
  dbi_casual_table_col_top_games_by_revenue: 'Top Games by Revenue',
  dbi_casual_table_col_rising_games_by_download: 'Rising Games by Downloads',
  dbi_casual_table_col_rising_games_by_dau: 'Rising Games by DAU',
  dbi_casual_table_col_rising_games_by_wau: 'Rising Games by WAU',
  dbi_casual_table_col_rising_games_by_mau: 'Rising Games by MAU',
  dbi_casual_table_col_rising_games_by_revenue: 'Rising Games by Revenue',

  // GenreTableSearch
  dbi_casual_genre_table_search_placeholder: 'Search any genre in the table',

  // 黑马游戏解释提示 - 卡片顶部
  // 月粒度
  dbi_casual_rising_games_tip_monthly_download:
    'Downloads Rising Games: Avg. Monthly Downloads > 500k, sort by rate of change (descending)',
  dbi_casual_rising_games_tip_monthly_mau: 'MAU Rising Games: Avg. MAU > 1M, sort by rate of change (descending)',
  dbi_casual_rising_games_tip_monthly_revenue:
    'Revenue($) Rising Games: Avg. Monthly Revenue($) > 200k, sort by rate of change (descending)',
  // 日粒度
  dbi_casual_rising_games_tip_daily_download:
    'Downloads Rising Games: Avg. Daily Downloads > 50k, sort by rate of change (descending)',
  dbi_casual_rising_games_tip_daily_dau: 'DAU Rising Games: Avg. DAU > 500k, sort by rate of change (descending)',
  dbi_casual_rising_games_tip_daily_revenue:
    'Revenue($) Rising Games: Avg. Daily Revenue($) > 10k, sort by rate of change (descending)',

  // 黑马游戏解释提示 - 表格列
  dbi_casual_rising_games_col_tip_monthly_download:
    'Downloads Rising Games: Avg. Monthly Downloads > 500k, sort by rate of change (descending)',
  dbi_casual_rising_games_col_tip_daily_download:
    'Downloads Rising Games: Avg. Daily Downloads > 50k, sort by rate of change (descending)',
  dbi_casual_rising_games_col_tip_dau: 'DAU Rising Games: Avg. DAU > 500k, sort by rate of change (descending)',
  dbi_casual_rising_games_col_tip_mau: 'MAU Rising Games: Avg. MAU > 1M, sort by rate of change (descending)',
};
